import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEdgeCoin = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 25,
	height: 24,
	viewBox: "425 62 578 666",
	...props,
	children: [/* @__PURE__ */ _jsxs("linearGradient", {
		id: "a",
		x1: 496.4,
		x2: 936.9,
		y1: 617.7,
		y2: 177.2,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", {
			offset: 0,
			style: { stopColor: "#0071bc" }
		}), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			style: { stopColor: "#29abe2" }
		})]
	}), /* @__PURE__ */ _jsx("path", {
		fill: "url(#a)",
		d: "M714.4 72.8 435.2 234v322.5l279.2 161.2 279.3-152.2V427.7L714.4 579.9l-159.9-92.3V302.9l159.9-92.4 159.9 92.3L602 462.1l112.4 63.8 279.3-149.8V234z"
	})]
});
export default SvgEdgeCoin;
